package com.tovtalk.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.layout.ContentScale
import com.tovtalk.ui.theme.TovTalkTheme

/**
 * TovTalkMediaFeed - Full-width feed image/video thumbnail
 * Uses TovTalkAsyncImage (expect/actual). When [fillCell] is true, fills the given modifier (e.g. grid cell) without forcing aspect ratio.
 */
@Composable
fun TovTalkMediaFeed(
    imageUrl: String?,
    modifier: Modifier = Modifier,
    aspectRatio: Float = MediaAspectRatio.VERTICAL_VIDEO,
    fillCell: Boolean = false
) {
    val safeAspectRatio = remember(aspectRatio) {
        if (MediaAspectRatio.isValidRatio(aspectRatio)) aspectRatio
        else MediaAspectRatio.DEFAULT_FALLBACK
    }
    val boxModifier = if (fillCell) {
        modifier
            .fillMaxSize()
            .clip(TovTalkTheme.shapes.medium)
            .then(
                if (!imageUrl.isNullOrBlank()) Modifier
                else Modifier.background(TovTalkTheme.colors.surfaceOverlay)
            )
    } else {
        modifier
            .fillMaxWidth()
            .aspectRatio(safeAspectRatio)
            .clip(TovTalkTheme.shapes.medium)
            .background(TovTalkTheme.colors.surfaceOverlay)
    }
    Box(modifier = boxModifier) {
        if (!imageUrl.isNullOrBlank()) {
            TovTalkAsyncImage(
                url = imageUrl,
                modifier = Modifier.fillMaxSize(),
                clipToCircle = false,
                contentScale = if (fillCell) ContentScale.Crop else ContentScale.Fit
            )
        }
    }
}
